import styled, { css, RuleSet } from 'styled-components';
import Text14 from '@sdk/components/ui/typography/Text14';
import Row from '@sdk/components/ui/spacing/Row';

export const ScoreRow = styled(Row)`
  justify-content: space-between;
`;

export const hoveredStyle = css`
  background-color: ${(props): string => props.theme.colors.primary}05;
  border-color: ${(props): string => props.theme.colors.primary};
`;

type ScoreProps = {
  isSet?: boolean;
};
export const Score = styled.div<ScoreProps>`
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid ${(props): string => props.theme.colors.separatorOnWhite};
  box-sizing: border-box;
  border-radius: 4px;
  margin: 10px 0 5px 0;

  &:hover {
    ${hoveredStyle}
  }

  ${(props): RuleSet<object> => props.isSet && hoveredStyle};
`;

export const ScoreText = styled(Text14)`
  ${Score}:hover & {
    color: ${(props): string => props.theme.colors.primary};
  }
`;
